import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avatar-upload" }
const _hoisted_2 = { for: "avatar-upload-input" }

import { ref } from "vue";
import { ElMessage } from "element-plus";
import { uploadImg } from "@/api/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadImg',
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const inputFile = ref(null);
// 头像上传
const updataAvatar = async (event) => {
  const listType = ["image/jpeg", "image/png", "image/gif"];
  const types = event.target.files[0]?.type;
  const imgType = listType.indexOf(types);
  const imgSize = event.target.files[0].size / 1024 / 1024 < 5;
  if (imgType == -1) {
    ElMessage.warning("上传图片不符合所需的格式！");
    return;
  }
  if (!imgSize) {
    ElMessage.warning(`上传图片大小不能超过5M！`);
    return;
  }
  // 获取文件
  let file = event.target.files[0];
  let formData = new FormData();
  formData.append("file", file);
  const res = await uploadImg(formData);
  if (res.data.code == 0) {
    emit("update:modelValue", res.data.data);
  } else {
    ElMessage.error(res.data.msg);
  }
  inputFile.value.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("input", {
      type: "file",
      onChange: updataAvatar,
      id: "avatar-upload-input",
      accept: ".jpg, .jpeg, .png, .gif",
      style: {"display":"none"},
      ref_key: "inputFile",
      ref: inputFile
    }, null, 544)
  ]))
}
}

})